import React, { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import clsx from 'clsx';
import { SvgIconReact, SvgIconType } from 'common/components/svg-icon';
import styles from './index.module.styl';
interface CustomHandleProps {
  type: `source` | `target`;
  position: Position;
  isSelected: boolean;
  showHandle: boolean;
}
export function CustomHandle(_ref: CustomHandleProps) {
  let {
    type,
    position,
    isSelected,
    showHandle
  }: CustomHandleProps = _ref;
  const [isInteractionZoneHovered, setIsInteractionZoneHovered] = useState<boolean>(false);
  const [isHandleHovered, setIsHandleHovered] = useState<boolean>(false);
  const isSourceNode = type === "source";
  const isTargetNode = type === "target";
  let pointerEvents: `auto` | `none` = "auto";
  if (isSourceNode && !isSelected) {
    pointerEvents = "none";
  }
  if (isTargetNode && !showHandle) {
    pointerEvents = "none";
  }
  let icon: SvgIconType = "arrow-right";
  switch (position) {
    case Position.Top:
      icon = "arrow-up";
      break;
    case Position.Bottom:
      icon = "arrow-down";
      break;
    case Position.Left:
      icon = "arrow-left";
      break;
    case Position.Right:
      icon = "arrow-right";
      break;
  }
  const handleMouseEnterInteractionZone = () => {
    if (isSourceNode) {
      setIsInteractionZoneHovered(true);
    }
  };
  const handleMouseLeaveInteractionZone = () => {
    if (isSourceNode) {
      setIsInteractionZoneHovered(false);
    }
  };
  const handleMouseEnterNodeHandle = () => {
    setIsHandleHovered(true);
  };
  const handleMouseLeaveNodeHandle = () => {
    setIsHandleHovered(false);
  };
  return <div className={clsx(styles.handleWrapper, {
    [styles.top]: position === Position.Top,
    [styles.bottom]: position === Position.Bottom,
    [styles.left]: position === Position.Left,
    [styles.right]: position === Position.Right,
    [styles.applyOffset]: isInteractionZoneHovered,
    [styles.selected]: isSelected,
    [styles.source]: isSourceNode,
    [styles.hoveredHandle]: isHandleHovered
  })} style={{
    opacity: showHandle ? 1 : 0,
    pointerEvents
  }} onMouseEnter={handleMouseEnterInteractionZone} onMouseLeave={handleMouseLeaveInteractionZone} data-sentry-component="CustomHandle" data-sentry-source-file="index.tsx">
      {isSourceNode && isSelected && <div className={styles.interactionZone}>
          {isInteractionZoneHovered ? <SvgIconReact className={styles.icon} icon={icon} /> : <div className={styles.visualIndicator} />}
        </div>}
      <Handle style={{
      pointerEvents
    }} type={type} position={position} id={"".concat(position, "-").concat(type)} {...isTargetNode ? {
      isConnectableStart: false
    } : {}} onMouseEnter={handleMouseEnterNodeHandle} onMouseLeave={handleMouseLeaveNodeHandle} data-sentry-element="Handle" data-sentry-source-file="index.tsx" />
    </div>;
}